<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        {{ katexUpdating ? 'Atualizar Fórmula' : 'Adicionar Fórmula' }}
      </v-card-title>
      <v-card-text>
        <div>
          <p>
            Use um editor para criar a fórmula e cole a expressão LaTeX no campo abaixo.
            Recomendamos <a
              href="https://www.codecogs.com/latex/eqneditor.php?lang=pt-br"
              target="_blank"
            >CodeCogs</a>
            ou <a
              href="https://www.latex4technics.com/"
              target="_blank"
            >Latex4Technics</a>.
          </p>
          <p>
            <a
              class="font-weight-bold"
              @click="insertSampleExpression"
            >Inserir fórmula de exemplo</a>
          </p>
        </div>
        <v-textarea
          v-model="katexInput"
          label="Expressão LaTeX"
          style="font-family: monospace;"
        />
        <div v-if="!invalidKatex">
          <div>Previsualização:</div>
          <!--  eslint-disable -->
            <div
              class="black--text mt-3"
              v-html="katexPreview"
            />
          </div>
          <div v-else class="red--text">
            Insira uma expressão LaTeX válida.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="primary" :disabled="invalidKatex" @click="onSubmit">
            {{ katexUpdating ? 'Atualizar' : 'Adicionar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import katex from 'katex'
export default {
  components: {
  },

  props: {
    kInput: { type: String, default: null }
  },

  data: () => ({
    katexInput: null,
    katexUpdating: false,
    invalidKatex: true,
    katexPreview: ''
  }),

  watch: {
    katexInput (value) {
      if (value === '') {
        this.invalidKatex = true
        return
      }

      try {
        this.katexPreview = katex.renderToString(value)
        this.invalidKatex = false
      } catch (e) {
        this.invalidKatex = true
      }
    }
  },

  created () {
    this.katexInput = this.kInput
  },

  methods: {

    insertSampleExpression () {
      this.katexInput = 'x=\\frac{-b\\pm\\sqrt{b^2-4ac}}{2a}'
    },

    onSubmit () {
      this.$emit('resolve', this.katexInput)
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
